import { useEffect, useState } from 'react'

// A permanent, always-visible clock -- deliberately not a toggleable panel
// like Calculator/Calendar below, since Dervent specifically described this
// one as "a permanent clock," not a click-to-open utility. Pure client-side,
// no backend call, no shared/persistent state -- there's nothing to sync.
//
// Genuinely visible on both mobile and desktop. Seconds remain visible on
// both layouts so this reads as a live physical clock rather than a static
// label; compact mobile sizing is handled by CSS instead of removing motion.
export function ClockDisplay({ isMobile }: { isMobile?: boolean }) {
  const [now, setNow] = useState(new Date())

  useEffect(() => {
    const interval = setInterval(() => setNow(new Date()), 1000)
    return () => clearInterval(interval)
  }, [])

  const time = isMobile
    ? now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false })
    : now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' })

  return (
    <span
      className={`ops-digital-clock-3d ${isMobile ? 'ops-digital-clock-3d-mobile' : ''}`}
      aria-label={`Current time ${time}`}
      aria-live="off"
    >
      {time}
    </span>
  )
}
